import { createCanonicalize } from "@karrotmarket-com/core";
import { isFunction, last } from "lodash";

import { canParse } from "~/utils/canParse";

import { CommonSearchParamKey } from "./CommonSearchParamKey";
import { buildRegionParamValue } from "./buildRegionParamValue";

/**
 * URL을 normalize 합니다.
 *
 * @returns normalize된 URL(pathname + querystring)
 */
export function normalizeHref(
  href: string,
  options: {
    origin: string;
    region: {
      id: string;
      name?: string;
    };
  },
): string {
  const isAbsoluteUrl = isFunction(URL.canParse)
    ? URL.canParse(href)
    : canParse(href);
  if (isAbsoluteUrl) {
    return href;
  }

  const isRelativeUrl =
    href === "" ||
    href.startsWith("/") ||
    href.startsWith("./") ||
    href.startsWith("../");

  const isExternalHrefMissingProtocol = !isRelativeUrl;
  if (isExternalHrefMissingProtocol) {
    return `http://${href}`;
  }

  const hrefUrl = new URL(href, options.origin);

  const hrefRegionIdParam = hrefUrl.searchParams.get(CommonSearchParamKey.In);
  const hrefRegionId = hrefRegionIdParam && last(hrefRegionIdParam.split("-"));

  /**
   * @description normalizeHref는 pathname과 queryString에만 관여를 합니다.
   * `createCanonicalize` - `stage` params는 origin에 연관되어 있어 아무 값이나 상관없기 때문에 `alpha`로 고정합니다.
   */
  const canonicalize = createCanonicalize("alpha");
  const { canonicalUrl } = canonicalize({
    url: hrefUrl.toString(),
  });

  const nextUrl = new URL(canonicalUrl);

  if (hrefRegionId === options.region.id) {
    nextUrl.searchParams.set(
      CommonSearchParamKey.In,
      buildRegionParamValue({
        region: options.region,
      }),
    );
  }

  if (!hrefRegionId) {
    nextUrl.searchParams.set(
      CommonSearchParamKey.In,
      buildRegionParamValue({
        region: options.region,
      }),
    );
  }

  nextUrl.searchParams.sort();
  return nextUrl.pathname + nextUrl.search;
}
